import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import appLib from "../../../libs/appLib.mjs";
import {Button, ButtonGroup, Form, Input, InputGroup, InputGroupText, Label, Progress} from "reactstrap";
import SliderPanel from "../../BaseLayout/SliderPanel.mjs";
import AppCpeCveExplorerIcon from "../../../media/app-images/AppCpeCveExplorerIcon.mjs";
import AppCpeCveIcon from "../../../media/app-images/AppCpeCveIcon.mjs";
import "./CveExplorer.css";
import CveLoadStatus from "../../../ComponentParts/CVE/CveLoadStatus.mjs";
import AppSearchIcon from "../../../media/app-images/AppSearchIcon.mjs";
import AppReloadIcon from "../../../media/app-images/AppReloadIcon.mjs";
import MetricInfoModal from "../../../ComponentParts/CVE/MetricInfoModal.mjs";
import PagedNavigation from "../../../ComponentParts/PagedNavigation/PagedNavigation.mjs";

const prefix = "CveExplorer";

const CpeCveExplorer = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			by: Glob.getPageParam('by'),
			ll: Glob.getLanguageLong(),
			pageSize: 25,
			range: [],
			clean: true
		};
		this.uid = Glob.generateUid(prefix);
		this.autoSort = this.autoSort.bind(this);
		this.sort = this.sort.bind(this);
		this.sortBy = this.sortBy.bind(this);
		this.fetchCves = this.fetchCves.bind(this);
	}

	componentDidMount() {
		Glob.setStatus('pageTitle', ['CVE','Cve Explorer']);
		Glob.setStatus('pageIcon', <AppCpeCveIcon />);
		Glob.register('currentPage', this.autoSort, this.uid);
		Glob.register('Prefs', () => {
			const ll = Glob.getLanguageLong();
			if (ll !== this.state.ll) this.setState({ll: ll});
		}, this.uid);
	}

	componentWillUnmount() {
		Glob.deregister(this.uid);
	}

	sortBy(axle) {
		if (axle === 'name') axle = undefined;
		if (axle === this.state.by) return;
		if (axle) {
			Glob.setCurrentPageParam('by', axle);
		} else {
			Glob.rmCurrentPageParam('by');
		}
	}
	sort() {
		if (this.state.resortTimeout) try { clearTimeout(this.state.resortTimeout); } catch (e) { }
		if ( ! this.state.cves ) return;
		const by = this.state.by || 'name';
		const currentPage = (() => {
			const c = Glob.getPageParam('page');
			if (c && !isNaN(Number(c))) return parseInt(c);
			return 1;
		})();
		let page = currentPage;
		let range = structuredClone(this.state.cves?.list || []);
		if (this.state.filter) {
			const f = this.state.filter.toLocaleLowerCase(this.state.ll).trim();
			range = range.filter(cve => cve.searchable.includes(f));
		}
		const totEntries = range.length;
		const pages = Math.ceil(totEntries / this.state.pageSize);
		range.sort((a, b) => b.name.toLocaleLowerCase(this.state.ll).localeCompare(a.name.toLocaleLowerCase(this.state.ll)));
		switch (this.state.by) {
			case 'score':
				range.sort((a, b) => (b?.metric?.baseScore ?? 0)-(a?.metric?.baseScore ?? 0));
				break;
			case 'description':
				range.sort((a, b) => (a.description ?? '').toLocaleLowerCase(this.state.ll).localeCompare((b.description ?? '').toLocaleLowerCase(this.state.ll)));
				break;
			default:
				break;
		}
		if ((page - 1) * this.state.pageSize > range.length) page = 1;
		range = range.slice((page - 1) * this.state.pageSize, page * this.state.pageSize);
		this.setState(
			{
				range: range,
				by: by,
				page: String(page),
				pages: pages,
				totFound: totEntries,
				loading: false,
				clean: false
			},
			() => {
				if (page !== currentPage) Glob.setCurrentPageParam('page', String(page));
			}
		);
	}

	autoSort(cp) {
		if (!cp) cp = Glob.getCurrentPage();
		const ns = {};
		if (cp.params.by !== this.state.by) ns.by = cp.params.by;
		if (cp.params.pageSize && parseInt(cp.params.pageSize) !== this.state.pageSize) ns.pageSize = parseInt(cp.params.pageSize);
		if (cp.params.filter !== this.state.filter) ns.filter = cp.params.filter;
		if (this.state.resortTimeout) {
			try { clearTimeout(this.state.resortTimeout); } catch (e) {}
			ns.resortTimeout = false;
		}
		this.setState(ns, this.sort);
	}

	fetchCves() {
		if (this.state.resortTimeout) try { clearTimeout(this.state.resortTimeout); } catch (e) {}
		if ( Glob.getPageParam('page') ) {
			this.setState({ loading: true, cves: false, range: [], resortTimeout: false }, ()=>{
				Glob.setCurrentPageParam('page');
				setTimeout( this.fetchCves, 100 );
			});
			return;
		}
		this.setState({loading: true, resortTimeout: false, cves:[] }, async () => {
			const cves = (await appLib.api('cve/match-triple', {params:{verbose:true},data:{vendor: this.state.vendor, product: this.state.model, version: this.state.version}}));
			cves.list = cves.list.map( c => {
				if ( ! c?.cve ) return null;
				const s = c.cve.toLocaleLowerCase(this.state.ll)+' '+c.cpe.toLocaleLowerCase(this.state.ll);
				return {
					id: c.cve,
					name: c.cve,
					description: c.cpe,
					searchable: s,
					metric: {
						baseScore: c.baseScore,
						baseSeverity: c.baseSeverity,
						vectorString: c.vectorString,
						vendor: c.vendor,
						product: c.product,
					}
				};
			}).filter( x => !! x?.id );
			this.setState({cves: cves}, this.sort);
		});
	}

	render() {
		return (
			<SliderPanel
				title={<TextLabel value={"Cve Explorer"} />}
				icon={<AppCpeCveExplorerIcon />}
				className={prefix}
			>
				<div className={"cve-search-panel limited"}>
					<Form onSubmit={e => {
						e.preventDefault();
						if ( ! this.state.vendor || this.state.vendor.trim().length < 3) return;
						if(! this.state.model || this.state.model.trim().length < 3) return;
						this.fetchCves();
					}}>
						<InputGroup>
							<InputGroupText>
								<Label>
									<TextLabel value={"Vendor"}/>:
								</Label>
							</InputGroupText>
							<Input
								required={true}
								autoFocus={true}
								id={'autofocusField-'+this.uid}
								value={this.state.vendor || ""}
								valid={ !! this.state.vendor && this.state.vendor.trim().length >= 3}
								invalid={ ! this.state.vendor || this.state.vendor.trim().length < 3}
								onChange={e => {
									this.setState({vendor: e.target.value});
								}}
							/>
						</InputGroup>
						<InputGroup>
							<InputGroupText>
								<Label>
									<TextLabel value={"Model"}/>:
								</Label>
							</InputGroupText>
							<Input
								required={true}
								value={this.state.model || ""}
								valid={ !! this.state.model && this.state.model.trim().length >= 3}
								invalid={ ! this.state.model || this.state.model.trim().length < 3}
								onChange={e => {
									this.setState({model: e.target.value});
								}}
							/>
						</InputGroup>
						<InputGroup>
							<InputGroupText>
								<Label>
									<TextLabel value={"Version"}/>:
								</Label>
							</InputGroupText>
							<Input
								value={this.state.version || ""}
								onChange={e => {
									this.setState({version: e.target.value});
								}}
							/>
						</InputGroup>
						<div className={"d-flex justify-content-between align-items-baseline"}>
							<div>
								{ (!! this.state.cves?.found) && <TextLabel value={"TotItemsFound"} params={{tot:(this.state.cves?.found||0).toLocaleString(this.state.ll)}} /> }
							</div>
							<ButtonGroup
								className={"btn-icon"}
							>
								<Button
									type={"reset"}
									color={"warning"}
									disabled={ this.state.clean }
									onClick={() => {
										this.setState({
											clean: true,
											vendor: '',
											model: '',
											version: '',
											cves: null,
											range: []
										}, ()=>{
											window.document.getElementById('autofocusField-'+this.uid).focus();
										});
									}}
								>
									<i>
										<AppReloadIcon />
									</i>
									<b>
										<TextLabel value={"Reset"} />
									</b>
								</Button>
								<Button
									disabled={ this.state.loading || ! this.state.model || this.state.model.trim().length < 3 || ! this.state.vendor || this.state.vendor.trim().length < 3 }
									color={"primary"}
									type="submit"
								>
									<b>
										<TextLabel value={"Search"}/>
									</b>
									<i>
										<AppSearchIcon/>
									</i>
								</Button>
							</ButtonGroup>
						</div>
					</Form>
					{ (this.state.loading) ? (
						<div className={"p-4 d-flex align-items-center"}>
							<div className={"pe-4"}>
								<AppCpeCveExplorerIcon style={{width:"96px",height:"96px",fill:"var(--comment-color)"}}/>
							</div>
							<div className={"flex-grow-1"}>
								<Progress striped animated value={100} />
							</div>
							<div className={"ps-4"}>
								<AppSearchIcon style={{width:"96px",height:"96px",fill:"var(--comment-color)"}}/>
							</div>
						</div>
					) : (
						this.state.clean && <CveLoadStatus />
					)}
				</div>
				{(! this.state.loading && this.state.range.length > 0) ? (
					<>
						<div className={"table-container limited"}>
							<PagedNavigation pages={this.state.pages} />
							<table className={"cves-list"} cellSpacing={0} cellPadding={0} border={0}>
								<thead>
								<tr>
									<th
										role={"button"}
										onClick={() => {
											this.sortBy('name')
										}}
										className={this.state.by === 'name' ? 'active' : ''}
									>
										<span>
											<TextLabel value={"CVE"}/>
										</span>
									</th>
									<th
										role={"button"}
										onClick={()=>{
											this.sortBy('score')
										}}
										className={this.state.by === 'score' ? 'active' : ''}
									>
										<span>
											<TextLabel value={"Severity"}/>
										</span>
									</th>
									<th
										role={"button"}
										onClick={() => {
											this.sortBy('description')
										}}
										className={this.state.by === 'description' ? 'active' : 'no-mobile'}
									>
										<span> <TextLabel value={"Description"}/> </span>
									</th>
								</tr>
								</thead>
								<tbody>
								{this.state.range.map((cve) => (
									<tr
										key={cve.id}
										onClick={ ()=>{ this.setState({metricsInfo: cve }) }}
									>
										<td>
											{cve.name ?? cve.id}
										</td>
										<td className={"severity "+(cve?.metric?.baseSeverity||'')}>
											<span>{ cve?.metric?.baseSeverity ?? (cve?.metric?.baseScore||0).toLocaleString(this.state.ll) }</span>
											<span>{ (cve?.metric?.baseScore||0).toLocaleString(this.state.ll) }</span>
										</td>
										<td className={"no-mobile desc"}>
											{cve.description ?? ''}
										</td>
									</tr>
								))}
								</tbody>
							</table>
							{ (!! this.state.metricsInfo) && (
								<MetricInfoModal
									cve={ this.state.metricsInfo.name ?? this.state.metricsInfo.id }
									metric={ this.state.metricsInfo.metric }
									close={ ()=>{ this.setState({metricsInfo: null}) }}
								/>
							)}
						</div>
					</>
				) : (
					(! this.state.clean) && (! this.state.loading) && (
						<h4 className={"text-center"}>
							<hr />
							<TextLabel value={"No items found"}/>
						</h4>
					)
				)}
			</SliderPanel>
		)
	}
}

export default CpeCveExplorer;
